import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp debe usarse dentro de AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [activeApp, setActiveApp] = useState('gestor'); // 'gestor' o 'messageGenerator'

  const switchApp = (app) => {
    setActiveApp(app);
  };

  const value = {
    activeApp,
    switchApp,
    isGestorActive: activeApp === 'gestor',
    isMessageGeneratorActive: activeApp === 'messageGenerator'
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
